export const formattedDateStringTz = (date: string | number | Date, timeZone: string) =>
  new Date(date).toLocaleString('en-US', { timeZone });
